import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ignore } from '@utils/object';
import Input from './components/StyledInput';
import Container from './components/Container';
import Counter from './components/Counter';

const withCounterProps = ['maxCounter', 'onChange', 'showCounter'];
const MAX_ROWS = 15;

class InputWithCounter extends PureComponent {
  constructor(props) {
    super(props);
    const { value } = props;
    this.state = {
      counter: value?.length || 0,
    };
  }

  onChange = value => {
    const { maxCounter, onChange } = this.props;
    const { length } = value;
    if (length <= maxCounter) {
      this.setState({ counter: length });
      onChange(value);
    }
  };

  render() {
    const { maxCounter, showCounter } = this.props;
    const { counter } = this.state;
    return (
      <Container>
        <Input
          {...ignore(this.props, withCounterProps)}
          onChange={this.onChange}
          isTextArea
          maxRows={MAX_ROWS}
        />
        {showCounter && <Counter>{`${counter}/${maxCounter}`}</Counter>}
      </Container>
    );
  }
}

InputWithCounter.defaultProps = {
  showCounter: true,
};

InputWithCounter.propTypes = {
  maxCounter: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  showCounter: PropTypes.bool,
  value: PropTypes.string,
};

export default InputWithCounter;
